import UploadZone from './UploadZone'

export default UploadZone
